export default __webpack_public_path__ + "static/media/motorcycle4.2c1517b1.png";